export const userReducer = (state = { user: {} }, action) => {
    switch (action.type) {
        case "LOGIN_REQUEST":
        case "REGISTER_USER_REQUEST":
        case "LOAD_USER_REQUEST":
            return {
                loading: true,
                isAuthenticated: false,
            };

        case "LOGIN_SUCCESS":
        case "REGISTER_USER_SUCCESS":
        case "LOAD_USER_SUCCESS":
            return {
                ...state,
                loading: false,
                isAuthenticated: true,
                user: action.payload,
            };
        case "LOGIN_FAIL":
        case "REGISTER_USER_FAIL":
            return {
                ...state,
                loading: false,
                isAuthenticated: false,
                user: null,
                error: action.payload,
            };
        case "LOAD_USER_FAIL":
            return {
                loading: false,
                isAuthenticated: false,
                user: null,
                error: action.payload,
            };
        case "LOGOUT_SUCCESS":
            return {
                loading: false,
                isAuthenticated: false,
                user: null,
            };
        case "LOGOUT_FAIL":
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case "CLEAR_ERRORS":
            return {
                ...state,
                error: undefined,
            };

        default:
            return state;
    }
};

export const profileReducer = (state = {}, action) => {
    switch (action.type) {
        case "UPDATE_PROFILE_REQUEST":
        case "UPDATE_PASSWORD_REQUEST":
        case "UPDATE_USER_REQUEST":
        case "DELETE_USER_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "UPDATE_PROFILE_SUCCESS":
        case "UPDATE_PASSWORD_SUCCESS":
        case "UPDATE_USER_SUCCESS":
            return {
                ...state,
                loading: false,
                isUpdated: action.payload,
            };

        case "DELETE_USER_SUCCESS":
            return {
                ...state,
                loading: false,
                isDeleted: action.payload.success,
                message: action.payload.message,
            };

        case "UPDATE_PROFILE_FAIL":
        case "UPDATE_PASSWORD_FAIL":
        case "UPDATE_USER_FAIL":
        case "DELETE_USER_FAIL":
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case "UPDATE_PROFILE_RESET":
        case "UPDATE_PASSWORD_RESET":
        case "UPDATE_USER_RESET":
            return {
                ...state,
                isUpdated: false,
            };

        case "DELETE_USER_RESET":
            return {
                ...state,
                isDeleted: false,
            };

        case "CLEAR_ERRORS":
            return {
                ...state,
                error: null,
            };

        default:
            return state;
    }
};

export const forgotPasswordReducer = (state = {}, action) => {
    switch (action.type) {
        case "FORGOT_PASSWORD_REQUEST":
        case "RESET_PASSWORD_REQUEST":
            return {
                ...state,
                loading: true,
                error: null,
            };
        case "FORGOT_PASSWORD_SUCCESS":
            return {
                ...state,
                loading: false,
                message: action.payload,
            };

        case "RESET_PASSWORD_SUCCESS":
            return {
                ...state,
                loading: false,
                success: action.payload,
            };

        case "FORGOT_PASSWORD_FAIL":
        case "RESET_PASSWORD_FAIL":
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case "CLEAR_ERRORS":
            return {
                ...state,
                error: null,
            };

        default:
            return state;
    }
};
